// export const urlApi = "http://localhost:8080"
// export const urlApp = "http://localhost:3000/"
export const urlApi = "https://mosyapay.com"
export const urlApp = "https://app.mosyapay.com/"

// kode api
// vqAyRKUtLTApwA6LCM5bz619EoArq3cx9m4imYjf

//push fil
//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